
import { Component, Prop, Vue } from 'vue-property-decorator';
import DialogImgLarge from '@/components/ImgLarge/index.vue';
import { UserModule } from '@/store/modules/user';
import { editStockApplyInout, getStockInoutTypeList } from '@/api/stock';

@Component({
  name: 'DialogDetail',
  components: {
    DialogImgLarge
  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  dialogDetailVisible!: Boolean;

  @Prop({
    type: Object,
    default: () => {}
  })
  recordDetail!: any;

  private inTypeOptions = [];
  private isTure='5';
  private inType:any='';
  private operateUserName=''
  created() {
    if (this.recordDetail.operate_user_name) {
      this.operateUserName = this.recordDetail.operate_user_name;
    } else {
      this.operateUserName = UserModule.getUserName;
    }
    this.getType();
  }
  private getType() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = UserModule.getCompanyId;
    params.company_name = UserModule.getCompanyName;
    params.type = parseInt(this.recordDetail.inout_type) === 1 ? '2' : '1';
    params.is_in_return = '0';
    params.is_out_check = '0';
    getStockInoutTypeList(params)
      .then((res) => {
        if (res.data) {
          this.inTypeOptions = res.data.list;
        }
      })
      .catch((error) => {
        let msg = error.msg;
      });
  }

  close() {
    this.$emit('close', false);
  }

  success() {
    if ((!this.inType || !this.inType.id) && parseInt(this.isTure) === 5) {
      let str = parseInt(this.recordDetail.inout_type) === 1 ? '请选择出库类型' : '请选择入库类型';
      this.showErrorMsg(str);
      return;
    }
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = UserModule.getCompanyId;
    params.company_name = UserModule.getCompanyName;
    params.apply_inout_id = this.recordDetail.id;
    params.check_remark = this.recordDetail.remark;
    params.check_inout_type_id = this.inType.id;
    params.check_inout_type_name = this.inType.name;
    params.check_inout_type = this.inType.type;
    params.state = this.isTure;

    editStockApplyInout(params)
      .then((res:any) => {
        this.showSuccessMsg(res.msg);
        this.$emit('success');
      })
      .catch((err) => {
        let msg = err.msg;
        this.showErrorMsg(msg);
      });
  }

  private getState(val: any) {
    // 1 已提交 3 已拒绝 5 已通过 7已退还 9 已收到
    let str = '';
    switch (parseInt(val.state)) {
      case 1:
        str = '已提交';
        break;
      case 3:
        str = '已拒绝';
        break;
      case 5:
        str = '已通过';
        break;
      case 7:
        str = '已退还';
        break;
      case 9:
        str = '已收到';
        break;
    }
    return str;
  }
  private large(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: [val],
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
